module.exports = __webpack_public_path__ + "static/img/item16.5568384.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item16.png
// module id = Om+4
// module chunks = 1